import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WorkflowIdPage.SingletonSteps.ActionSelector', {
    addAutoApprovalStep: 'Add Auto-Approval step',
    addReviewStep: 'Add review step',
});
